import $ from "jquery";

const tripInsight = ($block) => {
  const $items = $block.find(".trip-insight__item");

  $items.off("mouseover");
  $items.on("mouseover", function () {
    selectItem($block, $(this));
  });
};

const selectItem = ($block, $item) => {
  $block
    .find(".trip-insight__item--active")
    .removeClass("trip-insight__item--active");
  $item.addClass("trip-insight__item--active");

  $block
    .find(".trip-insight__image--active")
    .removeClass("trip-insight__image--active");
  $block
    .find(`.trip-insight__image[data-id="${$item.data("id")}"]`)
    .addClass("trip-insight__image--active");
};

export const reloadScriptTripInsight = () => {
  const $blocks = $(".trip-insight");

  $blocks.each(function () {
    tripInsight($(this));
  });
};
reloadScriptTripInsight();
